import { render, staticRenderFns } from "./Gradebook.vue?vue&type=template&id=0ae97644&scoped=true&"
import script from "./Gradebook.vue?vue&type=script&lang=js&"
export * from "./Gradebook.vue?vue&type=script&lang=js&"
import style0 from "./Gradebook.vue?vue&type=style&index=0&id=0ae97644&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae97644",
  null
  
)

export default component.exports